import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames/bind';
import FormattedPrice from 'components/FormattedPrice/FormattedPrice';
import Tooltip from 'components/Tooltip/Tooltip';
import styles from './CurrentBalance.module.scss';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import AccountSelect, {
  IAccountOption,
} from 'components/AccountSelect/AccountSelect';
import { CustomerStatus } from 'common/consts/customerStatus';

import { getPathnameFromUrl } from 'common/helpers/resolveHost';

interface Props {
  heading: string;
  currency: string;
  balance: number;
  balanceTooltip?: React.ReactNode;
  noPaymentPlan?: boolean;
  noPaymentPlanHeading?: string;
  noPaymentPlanLabel?: string;
  noPaymentPlanTooltip?: React.ReactNode;
  noPaymentPlanButtonLabel?: string;
  children?: React.ReactNode;
  className?: string;
  LayoutModel?: any;
  Model?: any;
  CurrentBalanceSecuredParaText?: string;
  ShowCurrentBalanceEmpty?: boolean;
}
const MARKET_SPAIN = 'Spain';
const CurrentBalance = ({
  heading,
  currency,
  balance,
  balanceTooltip,
  noPaymentPlan,
  noPaymentPlanHeading,
  noPaymentPlanTooltip,
  children,
  className,
  LayoutModel,
  Model,
  CurrentBalanceSecuredParaText,
  ShowCurrentBalanceEmpty
}: Props) => {
  const history = useHistory();
  const currentMarket = useAppSelector(selectCurrentMarket);

  const hasMultipleProfiles = (LayoutModel?.Profiles || []).length > 1;
  console.log(hasMultipleProfiles, 'console.log(hasMultipleProfiles');
  const accountsList: IAccountOption[] = useMemo(
    () =>
      (LayoutModel?.Profiles || []).map((acc: any, index: number) => ({
        value: Model?.ProfileUrls[index],
        reference:
          acc.Market === MARKET_SPAIN
            ? acc.DebtReference
            : acc.ReferenceToDisplay,
        balance:
          acc.Status != CustomerStatus.LegalProcess && !acc.IsClosed
            ? acc.FormattedCurrency
            : undefined,
        profileId: acc.ProfileId,
      })),
    [LayoutModel?.Profiles, Model?.ProfileUrls],
  );
  const onAccountChange = (profileUrl: string) => {
    var nextPagePath = getPathnameFromUrl(profileUrl);
    history.push(nextPagePath, {
      noRefresh: false,
    });
  };
  return (
    <div className={classnames(styles.currentBalance, className)}>
      {hasMultipleProfiles &&
        LayoutModel?.Settings?.EnableMultiAccountPortal &&
        ((LayoutModel?.Profiles !== null &&
          LayoutModel?.Profiles?.some(
            (x: any) => x.Status !== CustomerStatus.AccountClosed,
          )) ||
          Model.IsCmsEditMode) && (
          <div>
            <AccountSelect
              optionsList={accountsList}
              selectedOption={LayoutModel?.ProfileId}
              onChange={onAccountChange}
            />
          </div>
        )}

      <div className={styles.heading}>
        {heading}{' '}
        {balanceTooltip && (
          <Tooltip id="balanceTooltip">{balanceTooltip}</Tooltip>
        )}
      </div>
      {(ShowCurrentBalanceEmpty) ?
        '' :
      (<div className={styles.value}>
        {typeof balance === 'string' ? (
          <span dangerouslySetInnerHTML={{ __html: balance }} />
        ) : (
          <FormattedPrice price={balance} currency={currency} />
        )}
      </div>)
      }
      {CurrentBalanceSecuredParaText && (
        <div className={styles.secured_text}>
          {CurrentBalanceSecuredParaText}
        </div>
      )}
      {noPaymentPlan && (
        <div className={classnames(styles.noPlan, 'u-hidden')}>
          <h3 className={styles.noPlanHeading}>
            {noPaymentPlanHeading}
            {currentMarket !== Market.FR && (
              <Tooltip id="noPlanTooltip">{noPaymentPlanTooltip}</Tooltip>
            )}
          </h3>
        </div>
      )}
      {children}
    </div>
  );
};

export default CurrentBalance;
